import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import App from './App'
import './index.css'

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN as string
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string
const devBypass = import.meta.env.VITE_DEV_AUTH_BYPASS === 'true'

const tree = devBypass ? (
  <React.StrictMode>
    <App />
  </React.StrictMode>
) : (
  <React.StrictMode>
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `https://${auth0Domain}/api/v2/`,
        scope: 'openid profile email',
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
)

ReactDOM.createRoot(document.getElementById('root')!).render(tree)
